import { useMutation } from "@tanstack/react-query";

import { GraphQLAPI, GraphQLResult } from "@examspark/api";
import { OpenGraphResponse } from "@examspark/types";

export const useQueryGetOpenGraph = () => {
  return useMutation({
    mutationFn: async (url: string) => {
      const result = (await GraphQLAPI.query<{
        getOpenGraphMetadata: string;
      }>({
        query: /* GraphQL */ `
          query GetOpenGraphMetadata($input: ControllerInput!) {
            getOpenGraphMetadata(input: $input)
          }
        `,
        variables: {
          input: {
            action: "getOpenGraphMetadata",
            params: JSON.stringify({
              url,
            }),
          },
        },
      })) as GraphQLResult<{ getOpenGraphMetadata: string }>;

      if (result.data?.getOpenGraphMetadata) {
        return JSON.parse(
          result.data.getOpenGraphMetadata,
        ) as OpenGraphResponse["hybridGraph"];
      }
    },
  });
};
